<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :title="$t('settingsBookList.title')"
      :routeBackName="routeBackName"
    />
    <ul class="list-main-setting list-menu">
      <li class="item" v-if="manageHiddenBooks">
        <RowItem
          v-kiosk
          @click="goToHiddenBook"
          :title="$t('userDefaultFolders.hiddenbooks')"
          :HasIconItem="true"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        >
          <div class="mef-icon" style="font-size: 49px; color: #b2b2b2">x</div>
        </RowItem>
        <router-view />
      </li>
      <li class="item">
        <RowItem
          v-kiosk
          @click="customSort"
          :title="$t('mainTools.customPigeonsName')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="s"
        />
        <router-view />
      </li>
      <li class="item">
        <RowItem
          v-kiosk
          @click="goToActiveStore"
          :title="$t('mainTools.activeRepositoryName')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="r"
        />

        <router-view />
      </li>
    </ul>
  </div>
</template>

<script>
import menuService from "../../../../services/menu";
import LanguageSetting from "./LanguageSetting.vue";
import { mapGetters } from "vuex";
import config from "@/config/general.js";
import { Axios } from "@/services/_axios";
import shutdown from "@/services/shutdown";
import init from "@/config/init.js";
import * as advLocalStorage from "localforage";
export default {
  components: {
    LanguageSetting,
  },
  data() {
    return {
      routeBackName: "settings",
    };
  },
  computed: {
    //getviewPlaces
    ...mapGetters("userSetting", ["getviewPlaces"]),
    manageHiddenBooks() {
      return this.userSettings.settings.userConfig?.manageHiddenBooks;
    },
  },
  methods: {
    goToActiveStore() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.$store
        .dispatch("folders/setOpenTypePopup", "activeStore")
        .then(() => {
          this.$store
            .dispatch("folders/setListType", "activeStore")
            .then(() => {
              this.$store.dispatch("folders/togglePopupFolder", true);
            });
        });
      // this.$router.push({ name: "home" });
    },
    goToHiddenBook() {
      menuService.openHiddenBooksMenu();
    },
    customSort() {
      this.$store.dispatch("customSort/showCustomSort");
      menuService.closeMenu();
    },
    goToLanguageSetting() {
      // this.$router.push({ name: "language-setting" });
      menuService.OpenLanguageMenu();
    },
    goToAdvSettings() {
      if (config.serverConnection !== "offline") return;
      menuService.OpenAdvSettingsMenu();
    },
    //goToDisplaySetting
    goToDisplaySetting() {
      // this.$router.push({ name: "display-setting" });
      menuService.OpenDisplayMenu();
    },
    goToMareiMekomotSetting() {
      // this.$router.push({ name: "display-setting" });
      menuService.OpenMmMenu();
    },
    goToBooklistSetting() {
      // this.$router.push({ name: "display-setting" });
      menuService.OpenBooklistMenu();
    },
    goToBackupSetting() {
      // this.$router.push({ name: "backup-setting" });
      menuService.openBackup();
    },
    //setViewPlacesRegularly
    setViewPlacesTo() {
      this.userSettings.setSettings(
        "mm",
        !this.$store.state.userSetting.viewPlacesRegularly
      );
      this.$store.dispatch(
        "userSetting/setViewPlacesRegularly",
        !this.$store.state.userSetting.viewPlacesRegularly,
        {
          root: true,
        }
      );
    },

    async factoryReset() {
      if (config.serverConnection !== "offline") return;
      const url = init.getServer() + init.UsersDB.userReset;

      const ask_msg = this.$t("mainSettings.askFactoryData");
      let payload = {
        title: this.$t("mainSettings.resetData"),
        content: ask_msg,
        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act != this.$t("general.yes")) {
        return;
      }
      //send request to reset all user data
      try {
        await Axios.delete(url);

        //reset all localstorages

        localStorage.clear();
        await advLocalStorage.clear();

        const success_msg = this.$t("actionBook.resetSuccessful");
        payload = {
          title: "",
          content: success_msg,
          btns: [this.$t("general.confirm")],
        };
        await this.$msg(payload);

        //restart app
        if (globalThis.ELECTRON_ENV) globalThis.RELOAD_APP();
        else location.reload();
        //await shutdown.restart();
      } catch {
        const errmsg = this.$t("actionBook.resetError");
        payload = {
          title: this.$t("general.error"),
          content: errmsg,
          btns: [this.$t("general.confirm")],
        };
        await this.$msg(payload);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 3;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-main-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
}
.row-in-setting {
  cursor: pointer;
}
.red {
  color: red;
}
</style>
